import { api } from 'api/api';

import {
    ForgotPasswordRequestBody,
    LoginRequestBody,
    LoginResponse,
    LogoutRequestBody,
    RegisterRequestBody,
    RegisterResponse,
    ResetPasswordRequestBody,
    SignUpRequestBody,
} from './types';
import { parametrizeURL } from 'api/utils';

export const AUTHENTICATION_URL = 'Authentication' as const;
export const AUTHENTICATION_LOGIN_URL = `${AUTHENTICATION_URL}/LoginAsync` as const;
export const AUTHENTICATION_LOGOUT_URL = `${AUTHENTICATION_URL}/LogoutAsync` as const;
export const AUTHENTICATION_REGISTER_URL = `${AUTHENTICATION_URL}/RegisterAsync` as const;
export const AUTHENTICATION_FORGOT_PASSWORD_URL = `${AUTHENTICATION_URL}/ForgotPasswordAsync` as const;
export const AUTHENTICATION_RESET_PASSWORD_URL = `${AUTHENTICATION_URL}/ResetPasswordAsync` as const;
export const AUTHENTICATION_GET_USER_BY_TOKEN_URL = `${AUTHENTICATION_URL}/GetUserIdTokenAsync/{request}` as const;

export const createAccountLogin = (body: LoginRequestBody) => api.post<LoginResponse>(AUTHENTICATION_LOGIN_URL, body);

export const createAccountLogout = (body: LogoutRequestBody) => api.post<void>(AUTHENTICATION_LOGOUT_URL, body);

export const createAccountRegister = (body: RegisterRequestBody) =>
    api.post<RegisterResponse>(AUTHENTICATION_REGISTER_URL, body);

export const readUserIdByToken = (request: string) =>
    api.get<string>(parametrizeURL(AUTHENTICATION_GET_USER_BY_TOKEN_URL, { request }));

export const forgotPassword = (body: ForgotPasswordRequestBody) =>
    api.post<void>(AUTHENTICATION_FORGOT_PASSWORD_URL, body);

export const resetPassword = (body: ResetPasswordRequestBody) =>
    api.post<void>(AUTHENTICATION_RESET_PASSWORD_URL, body);
